import { Link } from 'react-router-dom';
import { heroBanners, siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  const banner = heroBanners[0];

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden" aria-label="主视觉区域">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20abstract%20composition%20with%20warm%20amber%20and%20deep%20crimson%20gradients%2C%20Asian%20cultural%20elements%20blending%20with%20digital%20patterns%2C%20luxurious%20theatrical%20atmosphere%2C%20soft%20bokeh%20lights%2C%20film%20grain%20texture%2C%20elegant%20minimalist%20background%20for%20video%20streaming%20platform&width=1800&height=900&seq=hero-banner-2026-01&orientation=landscape"
        alt="亚洲视频精选平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight leading-tight max-w-3xl">
          {banner.title}
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl leading-relaxed">
          {siteConfig.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/japan-korea"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-lg shadow-primary-500/30"
          >
            {banner.cta}
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-white/15 text-white font-medium text-sm border border-white/25 hover:bg-white/25 transition-all duration-300 cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-6 text-white/60 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-green-400"></i>
            高清画质
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-green-400"></i>
            海量内容
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-green-400"></i>
            每日更新
          </span>
        </div>
      </div>
    </section>
  );
}